import React from 'react';
import { Phone, Plus, X } from 'lucide-react';


export const StageCommunication = function({ planData, updateData }) {

  var WEEKDAYS_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var TIME_OPTIONS = [
    '6:00 AM', '6:30 AM', '7:00 AM', '7:30 AM', '8:00 AM', '8:30 AM', '9:00 AM', '9:30 AM',
    '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM',
    '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM',
    '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM', '6:00 PM', '6:30 PM',
    '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM', '9:00 PM',
  ];

  return (

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Primary Communication Method</label>
              <div className="space-y-2">
                {[
                  { id: 'app-only', name: 'Parentum App Only', desc: 'All communication through the Parentum co-parenting platform' },
                  { id: 'email', name: 'Email Only', desc: 'Written communication via email for documentation' },
                  { id: 'text-email', name: 'Text & Email', desc: 'Text for time-sensitive, email for important decisions' },
                  { id: 'usps', name: 'U.S. Postal Service Only', desc: 'All communication sent via USPS mail' },
                  { id: 'third-party', name: 'Through Third Party', desc: 'All communication facilitated through a designated third party' },
                  { id: 'any', name: 'No Restriction', desc: 'Any reasonable method including phone calls' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('preferredComm', opt.id); }}
                      data-testid={'comm-' + opt.id}
                      className={planData.preferredComm === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#5A4E9E] bg-[#5A4E9E]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Parentum App Cost Responsibility */}
            {planData.preferredComm === 'app-only' && (
              <div className="p-4 bg-[#5A4E9E]/5 border border-[#5A4E9E]/20 rounded-xl space-y-3" data-testid="app-cost-section">
                <label className="block text-sm font-medium">Who will pay for the costs associated with the Parentum app?</label>
                <div className="space-y-2">
                  {[
                    { id: 'plaintiff', name: 'Plaintiff pays for both accounts' },
                    { id: 'defendant', name: 'Defendant pays for both accounts' },
                    { id: 'split', name: 'Each party pays for their own account' },
                  ].map(function(opt) {
                    return (
                      <button key={opt.id} onClick={function() { updateData('appCostPayer', opt.id); }}
                        data-testid={'app-cost-' + opt.id}
                        className={'w-full p-3 rounded-lg border text-left text-sm font-medium transition-all ' + (planData.appCostPayer === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20 text-white/60')}>
                        {opt.name}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Third Party List */}
            {(planData.preferredComm === 'third-party') && (
              <div className="p-4 bg-[#5A4E9E]/5 border border-[#5A4E9E]/20 rounded-xl space-y-3" data-testid="third-party-section">
                <label className="block text-sm font-medium">Designated Third Parties</label>
                <p className="text-xs text-white/40">These individuals may also facilitate custody exchanges.</p>
                {planData.thirdParties.map(function(tp, i) {
                  return (
                    <div key={i} className="flex items-center gap-2">
                      <input type="text" value={tp}
                        onChange={function(e) {
                          var arr = planData.thirdParties.slice();
                          arr[i] = e.target.value;
                          updateData('thirdParties', arr);
                        }}
                        placeholder={'Third party ' + (i + 1) + ' (name, relationship, contact)'}
                        className="flex-1 bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2 text-sm focus:outline-none focus:border-[#5A4E9E]/40"
                        data-testid={'third-party-input-' + i} />
                      {planData.thirdParties.length > 1 && (
                        <button onClick={function() {
                          var arr = planData.thirdParties.filter(function(_, idx) { return idx !== i; });
                          updateData('thirdParties', arr);
                        }}
                          className="p-2 text-white/30 hover:text-white/60 transition-colors">
                          <X className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  );
                })}
                <button onClick={function() { updateData('thirdParties', planData.thirdParties.concat([''])); }}
                  className="text-sm text-[#5A4E9E] hover:underline flex items-center gap-1"
                  data-testid="add-third-party-btn">
                  <Plus className="w-4 h-4" /> Add another third party
                </button>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium mb-2">Response Timeframe for Non-Emergency Matters</label>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {[
                  { id: '24h', label: '24 Hours' },
                  { id: '48h', label: '48 Hours' },
                  { id: '72h', label: '72 Hours' },
                  { id: 'business', label: '2 Business Days' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('commTimeframe', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.commTimeframe === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Emergency Communication</label>
              <div className="grid grid-cols-3 gap-2">
                {[
                  { id: 'call', label: 'Phone Call' },
                  { id: 'text', label: 'Text Message' },
                  { id: 'both', label: 'Call + Text' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('emergencyComm', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.emergencyComm === opt.id ? 'border-[#EF4444] bg-[#EF4444]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Communication Boundaries (select all that apply)</label>
              <div className="space-y-2">
                {[
                  { id: 'child-only', label: 'Discuss only child-related matters' },
                  { id: 'no-disparage', label: 'No disparaging the other parent' },
                  { id: 'written-record', label: 'All significant decisions documented in writing' },
                ].map(function(opt) {
                  var checked = planData.commBoundaries.includes(opt.id);
                  return (
                    <label key={opt.id} className="flex items-center gap-3 p-3 bg-white/[0.02] border border-white/[0.06] rounded-lg cursor-pointer hover:bg-white/[0.04]">
                      <input type="checkbox" checked={checked}
                        onChange={function() {
                          updateData('commBoundaries', checked
                            ? planData.commBoundaries.filter(function(x) { return x !== opt.id; })
                            : planData.commBoundaries.concat([opt.id]));
                        }}
                        className="w-4 h-4 accent-[#5A4E9E]" />
                      <span className="text-sm text-white/70">{opt.label}</span>
                    </label>
                  );
                })}
              </div>
            </div>

            {/* Regular Phone Calls */}
            <div className="border-t border-white/[0.06] pt-6">
              <label className="flex items-center gap-3 p-3 bg-white/[0.02] border border-white/[0.06] rounded-lg cursor-pointer hover:bg-white/[0.04] mb-4" data-testid="phone-calls-toggle">
                <input type="checkbox" checked={planData.phoneCallsEnabled || false}
                  onChange={function() { updateData('phoneCallsEnabled', !planData.phoneCallsEnabled); }}
                  className="w-4 h-4 accent-[#5A4E9E]" />
                <Phone className="w-4 h-4 text-[#5A4E9E]" />
                <div>
                  <span className="text-sm font-medium text-white/80">Regular Phone Calls Between Parent & Child</span>
                  <p className="text-xs text-white/40">Schedule recurring phone or video calls when the child is with the other parent</p>
                </div>
              </label>

              {planData.phoneCallsEnabled && (
                <div className="p-4 bg-[#5A4E9E]/5 border border-[#5A4E9E]/20 rounded-xl space-y-4" data-testid="phone-calls-section">
                  {/* Frequency */}
                  <div>
                    <label className="block text-sm font-medium mb-2">Call Frequency</label>
                    <div className="grid grid-cols-2 gap-2">
                      {[
                        { id: 'daily', label: 'Daily', desc: 'Every day the child is with the other parent' },
                        { id: 'weekly', label: 'Weekly', desc: 'On selected day(s) each week' },
                      ].map(function(opt) {
                        return (
                          <button key={opt.id} onClick={function() { updateData('phoneCallFrequency', opt.id); }}
                            data-testid={'phone-freq-' + opt.id}
                            className={'p-3 rounded-lg border text-left transition-all ' +
                              (planData.phoneCallFrequency === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                            <p className="text-sm font-medium">{opt.label}</p>
                            <p className="text-xs text-white/40">{opt.desc}</p>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Day selection for weekly */}
                  {planData.phoneCallFrequency === 'weekly' && (
                    <div>
                      <label className="block text-sm font-medium mb-2">Which day(s)?</label>
                      <div className="flex flex-wrap gap-2">
                        {WEEKDAYS_FULL.map(function(day) {
                          var selected = (planData.phoneCallDays || []).includes(day);
                          return (
                            <button key={day} onClick={function() {
                              var current = planData.phoneCallDays || [];
                              updateData('phoneCallDays', selected
                                ? current.filter(function(d) { return d !== day; })
                                : current.concat([day]));
                            }}
                              data-testid={'phone-day-' + day.toLowerCase()}
                              className={'px-3 py-2 rounded-lg border text-sm font-medium transition-all ' +
                                (selected ? 'border-[#5A4E9E] bg-[#5A4E9E]/10 text-[#5A4E9E]' : 'border-white/10 hover:border-white/20 text-white/50')}>
                              {day.substring(0, 3)}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Time selection */}
                  {planData.phoneCallFrequency && (
                    <div>
                      <label className="block text-sm font-medium mb-2">Scheduled Call Time</label>
                      <select
                        value={planData.phoneCallTime || ''}
                        onChange={function(e) { updateData('phoneCallTime', e.target.value); }}
                        className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-[#5A4E9E]/40"
                        data-testid="phone-call-time-select"
                      >
                        <option value="" className="bg-[#FFFFFF]">Select a time</option>
                        {TIME_OPTIONS.map(function(t) {
                          return <option key={t} value={t} className="bg-[#FFFFFF]">{t}</option>;
                        })}
                      </select>
                      <p className="text-xs text-white/30 mt-1">The non-custodial parent may call the child at this time</p>
                    </div>
                  )}

                  {/* Call Recording */}
                  <div>
                    <label className="block text-sm font-medium mb-2">Phone Call Recording</label>
                    <div className="space-y-2">
                      {[
                        { id: 'no-recording', label: 'No Recording Permitted', desc: 'Neither party may record phone calls between the child and the other parent' },
                        { id: 'mutual-consent', label: 'Recording With Mutual Consent', desc: 'Calls may be recorded only if both parties agree in advance' },
                        { id: 'one-party', label: 'One-Party Consent Recording', desc: 'Either parent may record calls in accordance with applicable state law' },
                        { id: 'state-law', label: 'Per State Law', desc: 'Recording permitted to the extent allowed by the law of the state where the recording party is located' },
                      ].map(function(opt) {
                        return (
                          <button key={opt.id} onClick={function() { updateData('phoneCallRecording', opt.id); }}
                            data-testid={'phone-recording-' + opt.id}
                            className={'w-full p-3 rounded-lg border text-left transition-all ' +
                              (planData.phoneCallRecording === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                            <p className="text-sm font-medium">{opt.label}</p>
                            <p className="text-xs text-white/40">{opt.desc}</p>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        
  );
};
